import { GetTokensV6Params, GetUsersUserTokensV7Params } from '@/lib/reservoir/reservoir.generated';

export type SortOptionType = GetTokensV6Params | GetUsersUserTokensV7Params;

export type SortOption<T extends SortOptionType> = {
  label: string;
  value: Required<Pick<T, 'sortBy' | 'sortDirection'>>;
};

export type CollectionSortOption = SortOption<GetTokensV6Params>;

export const COLLECTION_SORT_OPTIONS: CollectionSortOption[] = [
  {
    label: 'price-asc',
    value: { sortBy: 'floorAskPrice', sortDirection: 'asc' },
  },
  {
    label: 'price-desc',
    value: { sortBy: 'floorAskPrice', sortDirection: 'desc' },
  },
  {
    label: 'rarity-desc',
    value: { sortBy: 'rarity', sortDirection: 'asc' },
  },
  {
    label: 'rarity-asc',
    value: { sortBy: 'rarity', sortDirection: 'desc' },
  },
];

export const COLLECTION_DEFAULT_SORT_OPTION = COLLECTION_SORT_OPTIONS[0];

export type UserTokensSortOption = SortOption<GetUsersUserTokensV7Params>;

export const USER_TOKENS_SORT_OPTIONS: UserTokensSortOption[] = [
  {
    label: 'acquired-at-desc',
    value: { sortBy: 'acquiredAt', sortDirection: 'desc' },
  },
  {
    label: 'acquired-at-asc',
    value: { sortBy: 'acquiredAt', sortDirection: 'asc' },
  },
  {
    label: 'last-appraisal-value-asc',
    value: { sortBy: 'lastAppraisalValue', sortDirection: 'desc' },
  },
  {
    label: 'last-appraisal-value-desc',
    value: { sortBy: 'lastAppraisalValue', sortDirection: 'asc' },
  },
];

export const USER_TOKENS_DEFAULT_SORT_OPTION = USER_TOKENS_SORT_OPTIONS[0];

// Initial (max) amount of facets shown, also used for show more amount.
export const MAX_FACET_ITEMS = 10;
